<template>
    <div class="h100">
        <div class="h100 flex-column scroll">
            <div class="flex w100 bg-white pt15 pl15 pr15">
                <div>
                    <span class="fs15 bold">大型器械加班</span>
                </div>
                <div class="flex-width"></div>
                <!-- <div @click="openPrint"  style="background-color: #eb6d69; height: 25px; line-height: 25px; color: white;" class="fs12 pl12 pr12 cursor-pointer no-print">打印</div> -->
            </div>
            <div class="flex items-center bg-white pl15 pr15 pb15">
                <div class="flex-width flex items-center mt10">
                    <div class="fs12 flex-width">
                        <div class="a70">创建人</div>
                        <div>{{apply.create_person}}</div>
                    </div>
                    <div class="fs12 flex-width ml10">
                        <div style="color:grey">创建日期</div>
                        <div>{{ apply.create_time }}</div>
                    </div>
                </div>
            </div>
           
            <div class="mt15 bg-white pd15">
                <div class="">
                    <div class="">
                        <div>
                            <div class="fs14 bold">
                                详细信息
                            </div>
                            <div class="flex mt30">
                                <div class="flex-width">
                                    <div class="fs12 a70">项目名称</div>
                                    <div class="fs13">{{ (apply.project_name)?apply.project_name:"--" }}</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">作业班组</div>
                                    <div class="pd5 br5 fs12 white mr5" style="background-color: #1890FF; display: inline-block;color:white" v-for="(org, idx) in apply.organizes_name" :key="idx">
                                        {{org}}
                                    </div>
                                    <!-- <div class="fs13">{{ apply.organizes_name}}</div> -->
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">楼栋号</div>
                                    <div class="fs13">{{ (apply.building_id)?apply.building_id:"--" }}</div>
                                </div>
                            </div>
                            <div class="flex mt30">
                                <div class="flex-width">
                                    <div class="fs12 a70">加班数量</div>
                                    <div class="fs13">{{ (apply.worker_count)?apply.worker_count:"--" }}</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">机械编号</div>
                                    <div class="fs13">¥{{ (apply.machine_id)?apply.machine_id:"--" }}</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">加班内容</div>
                                    <div class="fs13">{{ (apply.content)?apply.content:"--" }}</div>
                                </div>
                            </div>

                            <!-- <div class="flex mt30">
                                <div class="flex-width">
                                    <div class="fs12 a70">附件</div>
                                    <div class="fs13 pr20" v-if="apply.data.attachment.length != 0">
                                        <div v-for="(src, i) in apply.data.attachment" :key="i">
                                            <div class="flex items-center">
                                                <a class="one-line flex-width" @click="preview(src)" style="text-decoration:none;">
                                                    <span>{{src.name}}</span>
                                                </a>
                                                <a-icon type="vertical-align-bottom" @click="downFile(src)"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="fs13 pr20" v-else>--</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">备注</div>
                                    <div class="fs13">{{ (apply.data.remark)?apply.data.remark:"--" }}</div>
                                </div>
                                <div class="flex-width"></div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt15 bg-white pd15">
                <div class="flex">
                    <div class="flex-width">
                        <div>
                            <div class="fs14 bold">
                                加班详情
                            </div>
                            <div class="flex mt15 w100">
                                <a-menu v-model="current" mode="horizontal" >
                                    <a-menu-item key="2"> <a-icon type="mail" />施工前照片 </a-menu-item>
                                    <a-menu-item key="3"> <a-icon type="appstore" />施工后照片 </a-menu-item>
                                    <a-menu-item key="1"> <a-icon type="setting" />施工日记 </a-menu-item>
                                    <a-menu-item key="4"> <a-icon type="appstore" />加班单 </a-menu-item>
                                </a-menu>
                            </div>
                            <div class="pd15" v-if="current==2">
                                <div>
                                    <div class="fs14 a60">施工前照片</div>
                                    <div class="mt10 br10 overflow-hidden" v-if="apply.attachment.before.length > 0" @click="preview">
                                        <div class="mb10" v-for="item in apply.attachment.before" :key="item.id" style="height: 200rpx;">
                                            <img :src="item.image" mode="" class="" style="width: 200px;height: 200px;"></img>
                                        </div>
                                    </div>
                                    <div v-else class="mt10 bg-white br10 flex-column items-center content-center" style="height: 300rpx;">
                                        <u-icon class="a60" name="/static/assets/wajueji.png" size="50"></u-icon>
                                        <div class="fs12 mt5 a60">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pd15" v-else-if="curTab==3">
                                <div>
                                    <div class="fs14 a60">施工后照片</div>
                                    <div class="mt10" v-if="apply.attachment.after.length > 0" @click="preview(apply.attachment.after)">
                                        <div class="mb10" v-for="item in apply.attachment.after" :key="item.id" style="height: 300rpx;">
                                            <img :src="item.image" mode="aspectFill" class="w100 h100"></img>
                                        </div>
                                    </div>
                                    <div v-else class="mt10 bg-white br10 flex-column items-center content-center" style="height: 300rpx;">
                                        <u-icon class="a60" name="/static/assets/wajueji.png" size="50"></u-icon>
                                        <div class="fs12 mt5 a60">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pd15" v-else-if="curTab==1">
                                <div>
                                    <div class="fs14 a60">施工日记照片</div>
                                    <div class="mt10" v-if="apply.attachment.logs.length > 0" @click="preview(apply.attachment.logs)">
                                        <div class="mb10" v-for="item in apply.attachment.logs" :key="item.id" style="height: 300rpx;">
                                            <img :src="item.image" mode="aspectFill" class="w100 h100"></img>
                                        </div>
                                    </div>
                                    <div v-else class="mt10 bg-white br10 flex-column items-center content-center" style="height: 300rpx;">
                                        <u-icon class="a60" name="/static/assets/wajueji.png" size="50"></u-icon>
                                        <div class="fs12 mt5 a60">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pd15" v-else-if="curTab==4">
                                <img v-if="apply.attachment.ticket != null" :src="apply.attachment.ticket" mode="widthFix" class="w100" @click="previewImage(apply.attachment.ticket)"></img>
                                <div v-else>
                                    <div class="mt10 bg-white br10 flex-column items-center content-center" style="height: 300rpx;">
                                        <u-icon class="a60" name="/static/assets/wajueji.png" size="50"></u-icon>
                                        <div class="fs12 mt5 a60">暂无图片</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt15 bg-white pd15">
                <div class="flex">
                    <div class="flex-width">
                        <div>
                            <div class="fs14 bold">
                                系统信息
                            </div>
                            <div class="flex mt15">
                                <div class="flex-width">
                                    <div class="fs12 a70">发起人</div>
                                    <div class="fs13" v-if="apply.create_person != null && apply.create_person != ''">{{ apply.create_person }}</div>
                                    <div class="fs13" v-else>--</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">发起时间</div>
                                    <div class="fs13" v-if="apply.create_time != null && apply.create_time != ''">{{ apply.create_time }}</div>
                                    <div class="fs13" v-else>--</div>
                                </div>
                            </div>
                            <div class="flex mt30">
                                <div class="flex-width">
                                    <div class="fs12 a70">修改人</div>
                                    <div class="fs13" v-if="apply.modify_person != null && apply.modify_person != ''">{{ apply.modify_person }}</div>
                                    <div class="fs13" v-else>--</div>
                                </div>
                                <div class="flex-width">
                                    <div class="fs12 a70">修改时间</div>
                                    <div class="fs13" v-if="apply.update_time != null && apply.update_time != ''">{{ apply.update_time }}</div>
                                    <div class="fs13" v-else>--</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-modal
            title="加签"
            :visible="visibleAdjust"
            :width="600"
            @ok="addAdjust"
            okText="确认"
            cancelText="取消"
            @cancel="visibleAdjust=false"
        >	
                <div>
                    <div class="mb5">请选择加签人</div>
                    <div class="w100">
                        <ChoosePersonBox v-model="adjustForm.persons"></ChoosePersonBox>
                    </div>
                    
                </div>
                <div class="mt20">
                    <div class="mb5">请输入加签意见</div>
                    <a-textarea
                        v-model="adjustForm.text"
                        placeholder="填写加签意见"
                        :auto-size="{ minRows: 3, maxRows: 5 }"
                    />
                </div>

        </a-modal>
        <a-modal title="预览" v-model="image_visible" @ok="downImg(preview_url)" okText="下载到本地" cancelText="返回" @cancel="image_visible = false">
            <div class="">
                <img :src="preview_url" alt="" width="100%" height="100%" style="object-fit: contain;">
            </div>
        </a-modal>
        <a-modal
            :title="previewDoc.title"
            :visible="docVisible"
            width="100%"
            centered
            @cancel="docVisible=false"
            :footer="null"
            >
       
            <div v-if="previewDoc.isPdf">
                <pdf :src="previewDoc.url" v-for="item in numPages"
                    :key="item"
                    :page="item"
                ></pdf>
            </div>
            <div v-else>
                <VueDocPreview :value="previewDoc.url" :type="previewDoc.docType" />
            </div>
        </a-modal>
        <a-modal v-model="accept_visible" :width="600" @ok="confirmAccept" okText="确定" cancelText="取消">
            <div>
                <div>
                    <div>备注</div>
                    <div class="mt10">
                        <a-textarea v-model="message" placeholder="请输入备注" :rows="4" />
                    </div>
                </div>
            </div>
        </a-modal>

        <a-modal v-model="reject_visible" :width="600" @ok="confirmReject" okText="确定" cancelText="取消">
            <div>
                <div>
                    <div>拒审原因</div>
                    <div class="mt10">
                        <a-textarea v-model="message" placeholder="请输入拒审原因" :rows="4" />
                    </div>
                </div>
            </div>
        </a-modal>

        <a-modal
			title="机械需求申请单"
			:visible="detail_visiable"
			@cancel="detail_visiable=false"
			:width="1000"
		>   
			<div ref="printArea">
                <CardMachineApplyPrintDetail :form="apply"></CardMachineApplyPrintDetail>
                <div  class="fs15 bold flex items-center mt20">
                    <div class="fs14 mr20" style="font-weight: 600;color:black;white-space: nowrap;">
                        审批进度
                    </div>
                    <div class="flex-width"></div>
                </div>
                <a-steps progress-dot :current="apply.step" :status="(apply.status == 0)?'wait':((apply.status == 1)?'finish':'error')" class="mt20 flex" size="small" style="justify-content: center;">
                    <a-step v-for="item, index in approvalDetail" :key="index">
                        <template slot="title">
                            <span style="font-size: 14px;">{{item.name}}</span>
                        </template>
                        <span slot="description">
                            <div>
                                <div v-if="item.status == 0" style="font-size: 12px;white-space: nowrap;">等待审批</div>
                                <div v-else style="font-size: 12px;white-space: nowrap;color:grey">审批时间:{{ item.process_time }}</div>
                            </div>
                            <div v-if="item.status != 0 && item.remark != null && item.remark != ''" style="font-size: 12px;white-space: nowrap;color:grey">
                                备注: {{item.remark}}
                            </div>
                        </span>
                        <span slot="description" style="position: absolute;top: 0%;">
                        </span>
                    </a-step>
                </a-steps>
			</div>
            <template #footer>
                <a-button icon="download" key="submit" type="danger" @click="print" class="no-print">打印</a-button>
            </template>
		</a-modal>
    </div>
</template>
<script>
    import CardApprovalDetail from './CardApprovalDetail.vue';
    import pdf from 'vue-pdf'
    import VueDocPreview from 'vue-doc-preview'
    import ChoosePersonBox from '../../views/common/ChoosePersonBox.vue'
    import CardApprovalNote from '../../components/Cards/CardApprovalNote.vue'
    import CardMachineApplyPrintDetail from './CardMachineApplyPrintDetail.vue'

	export default {
        props:{
            apply:{
                type: Object,
            },
            approvalDetail:{
                type: Array,
            },
            approvalForm:{
                type: Object,
            }
        },
		components: {
            CardApprovalDetail, pdf, VueDocPreview, CardApprovalNote, ChoosePersonBox, CardMachineApplyPrintDetail
        },
		data() {
			return {
                data:[],
                columns:[
                    {
                        title: '序号',
                        dataIndex: 'key',
                        key: 'key',
                        width:'5%',
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'name',
                        key: 'name',
                        width:'15%',
                        scopedSlots: { customRender: 'name' },
                    },
                    {
                        title: '物资规格',
                        dataIndex: 'size',
                        key: 'size',
                        ellipsis: true,
                    },
                    {
                        title: '物资单位',
                        dataIndex: 'unit',
                        key: 'unit',
                        width:'10%',
                    },
                    {
                        title: '调运数量',
                        dataIndex: 'count',
                        key: 'count',
                        width:'10%',
                        scopedSlots: { customRender: 'count' },
                    },
                ],
                page:{
                    page:1, totoal:0
                },
                feeColumns:[
                    {
                        title: '序号',
                        dataIndex: 'key',
                        key: 'key',
                        width:'5%'
                    },
                    {
                        title: '摘要',
                        dataIndex: 'title',
                        key: 'title',
                        width:'40%',
                        scopedSlots: { customRender: 'name' },
                    },
                    {
                        title: '金额',
                        dataIndex: 'amount',
                        key: 'amount',
                        width:'10%',
                        scopedSlots: { customRender: 'remark' },
                    },
                    {
                        title: '科目',
                        dataIndex: 'text',
                        key: 'text',
                        width:'25%',
                        scopedSlots: { customRender: 'sale_unit_price' },
                    },
                    {
                        title: '单据张数',
                        dataIndex: 'count',
                        key: 'count',
                        width:'10%',
                        scopedSlots: { customRender: 'count' },
                    },
                    // {
                    //     title: '操作',
                    //     dataIndex: 'operation',
                    //     width:'10%',
                    //     scopedSlots: { customRender: 'operation' },
                    // },
                ],
                visibleAdjust:false,
                image_visible:false,
                preview_url:"",
                docVisible:false,
                previewDoc: {
                    title: "",
                    isPdf: false
                },
                adjustForm:{persons:[], text:""},
                message:null,
                accept_visible:false,
                reject_visible:false,
                detail_visiable:false,
                current:2,
			}
		},
        created(){
            
        },
        mounted() {
             // 在下一个 DOM 更新周期中执行
                this.$nextTick(() => {
                    setTimeout(() => {
                        const tailElements = document.querySelectorAll(".ant-timeline-item-tail");
                        tailElements.forEach(element => {
                        element.remove();
                        });
                    }, 0);
                });
        },
        methods:{
            setup(id) {
                this.$nextTick(()=>{
                    this.$refs.note.getAnnotationList(id, 11)
                })
            },
            async reject() {
                this.message = null
                this.reject_visible = true;
            },
            async confirmReject() {
                if (this.message == null || this.message == "") {
                    this.$message.error('请输入拒审原因');
                    return;
                }
                let rs = await this.$api.rejectFlow(this.apply.id, this.message);
                if (rs.err == 0) {
                    this.$message.success('操作成功');
                    this.someAction()
                    this.reject_visible = false;
                } else {
                    this.$message.error('操作失败');
                }
            },
            async accept() {
                this.message = null
                this.accept_visible = true;
            },
            async confirmAccept() {
                let rs = await this.$api.acceptFlow(this.apply.id, this.message);
                if (rs.err == 0) {
                    this.$message.success("审批通过")
                    this.someAction()
                    this.accept_visible = false;
                } else if (rs.err == 2) {
                    this.$message.error("操作失败，请重试或联系管理员")
                }
            },
            async withdrawFlow(){
                let rs = await this.$api.withdrawFlow(this.apply.id);
                if (rs.err == 0) {
                    const newParam = {key:1, data:[]};
                    this.$emit('update-param', newParam);
                } 
            },
            cuiban(){

            },
            async relaunchFlow(){
                let rs = await this.$api.relaunchFlow(this.apply.id);
                if (rs.err == 0) {
                    const newParam = {key:1, data:[]};
                    this.$emit('update-param', newParam);
                }
            },
            addAdjust(){
                for(let item of this.adjustForm.persons){
                    let check = this.approvalDetail.find(it=>it.uid == item)
                    if(check != null){
                        this.$message.error("加签人重复，请重新选择")
                        return;
                    }
                }
                const newParam = {key:2, data: this.adjustForm};
                this.$emit('update-param', newParam);
               	this.visibleAdjust = false
            },
            preview(item){
                this.previewDoc.title = item.name;
                this.previewDoc.url = item.url;
                this.preview_url = item.url;
                let suffix = this.previewDoc.title.substring(this.previewDoc.title.lastIndexOf(".") + 1).toLowerCase()
                if(suffix == "jpg" || suffix == "png"){
                    this.image_visible = true
                }else if(suffix == "docx" || suffix == "xlsx" || suffix == "pptx"){
                    this.previewDoc.url = "https://api.hidocs.cn/api?furl=" + this.previewDoc.url;
                    window.open(this.previewDoc.url)
                }else{
                    if (suffix != "pdf" && suffix != "mp4") {
                        this.previewDoc.url = "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(this.previewDoc.url);
                        window.open(this.previewDoc.url)
                        this.previewDoc.isPdf = false;
                        this.previewDoc.docType = "office";
                        // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(item.url));

                        // this.docVisible = true;
                    }else{
                        const link = document.createElement('a');
                        link.href = item.url;
                        link.download = item.name; // 设置下载的文件名，根据实际需要修改
                        link.target = '_blank'; // 在新窗口打开下载链接
                        link.click(); // 模拟点击触发下载
                    }
                } 
            },
            downImg(item){
                this.getBlob(this.previewDoc.url, (blob) => {
                    this.saveAs(blob, this.previewDoc.title)
                })
            },
            downFile(src){
                this.getBlob(src.url, (blob) => {
                    this.saveAs(blob, src.name)
                })
            },
            getBlob(url, cb) {
                var xhr = new XMLHttpRequest()
                xhr.open('GET', url, true)
                xhr.responseType = 'blob'
                xhr.onload = function() {
                    if (xhr.status === 200) {
                    cb(xhr.response)
                    }
                }
                xhr.send()
            },
            saveAs(blob, filename) {
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, filename)
                }
                else {
                    var link = document.createElement('a')
                    var body = document.querySelector('body')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename

                    link.style.display = 'none'
                    body.appendChild(link)

                    link.click()
                    body.removeChild(link)
                    window.URL.revokeObjectURL(link.href)
                }
            },
           
            someAction() { 
                const newParam = {key:1, data:[]};
                this.$emit('update-param', newParam);
            },

            updateParam(newParam){
                this.$emit('update-param', newParam);
            },
            openPrint(){
                this.detail_visiable = true
            },
            print() {
                this.$nextTick(() => {
                    // 创建新的窗口以防止干扰主页面
                    const printWindow = window.open('', '_blank', 'width=800,height=600');

                    // 获取主页面的所有样式表
                    const styleSheets = Array.from(document.styleSheets)
                    .map(sheet => {
                        try {
                        return sheet.href ? `<link rel="stylesheet" type="text/css" href="${sheet.href}">` : '';
                        } catch (e) {
                        console.error('无法访问样式表：', sheet, e);
                        return '';
                        }
                    })
                    .join('');

                    // 获取内联样式和必要的script（如页面中使用了某些需要的JS库来控制格式）
                    const inlineStyles = document.head.querySelectorAll('style');
                    let inlineStyleStr = '';
                    inlineStyles.forEach(style => {
                        inlineStyleStr += style.outerHTML;
                    });
                    // 写入内容和样式
                    printWindow.document.write(`
                    <html>
                        <head>
                        ${styleSheets}
                        ${inlineStyleStr}
                        <style>
                            @media print {
                            .no-print { display: none; }
                            }
                        </style>
                        </head>
                        <body>
                        ${this.$refs.printArea.innerHTML}
                        </body>
                    </html>
                    `);
                    printWindow.document.close();

                    // 延迟执行打印和关闭操作，确保内容正确渲染
                    printWindow.focus();
                    setTimeout(() => {
                    printWindow.print();
                    printWindow.close();
                    }, 1000); // 延迟 1000 毫秒后执行打印和关闭
                });
            },   
        }
	}

</script>
<style scoped>
@media print {  
    /* 隐藏不需要打印的元素，例如整个 a-modal 容器（如果你不想打印它） */  
    /* .ant-modal {  
        display: none !important;  
    }   */
  
    /* 确保只打印 .print-section 内的内容 */  
    /* body * {  
        visibility: hidden;  
    }   */
  
    /* .print-section, .print-section * {  
        visibility: visible;  
    }   */
  
    /* 额外的样式调整，如边距、字体等 */  
    /* .print-section {  
        position: absolute;  
        left: 0;  
        top: 0;  
        width: 100%;  
        overflow: hidden;  
    }   */
  
    /* 如果需要，隐藏打印按钮（尽管它已经在 .ant-modal 内被隐藏了） */  
    .no-print {  
        display: none !important;  
    }  
}
</style>
